import React from 'react';
import { useI18n } from '@/i18n/I18nProvider';
import clsx from 'clsx';
import RefreshBar from '@/components/RefreshBar';
import StudentList from './components/StudentList';

export default function DashboardPage() {
  const { locale } = useI18n();

  return (
    <div className={clsx('space-y-4', locale === 'ar' && 'direction-rtl')}>
      {/* Page Header with Heading & Refresh Bar */}
      <div className="mb-2">
        <div className="py-2 md:py-3">
          <div className="flex items-center justify-between gap-3 min-w-0 overflow-hidden">
            {/* Page Heading */}
            <div className="flex items-center gap-3 min-w-0 flex-1 overflow-hidden">
              <div className="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center flex-shrink-0">
                <svg className="w-6 h-6 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                  />
                </svg>
              </div>
              <div className="min-w-0">
                <h1 className="text-xl sm:text-2xl font-bold text-foreground">
                  {locale === 'ar' ? 'أبنائي' : 'My Children'}
                </h1>
                <p className="text-sm text-muted-foreground mb-0 truncate">
                  {locale === 'ar' ? 'إدارة ومتابعة بيانات الأطفال' : "Manage and track your children's information"}
                </p>
              </div>
            </div>

            {/* Refresh Bar */}
            <div className="flex items-center gap-1 md:gap-2 min-w-0 flex-shrink-0">
              <RefreshBar className="flex-shrink-0 min-w-0" />
            </div>
          </div>
        </div>
      </div>

      {/* Student Cards List */}
      <StudentList />
    </div>
  );
}
